/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import { take } from 'rxjs';

import {
  CreateOrCopyPrintListRes,
  editPrintListService,
} from '../../../../services/editPrintList.service.ts';
import { GeneralForm } from './components/generalForm.component.tsx';
import { IGeneralTab } from './general.tab.tsx';
import { editPrintListTabLoadingService } from '../editPrintListTabLoading.service.ts';
import { modeService } from '../../../../../../shared/services/mode/mode.service.ts';
import { responseHandler } from '../../../../../../shared/responseHandler/responseHandler.ts';
import { Wa_CreateProductionPrintListInput } from '../../../../../../graphql/generatedModel.ts';

export const GeneralCopyTab: FC<Pick<IGeneralTab, 'mode'>> = ({ mode }) => {
  const { t } = useTranslation();
  const { getValues, handleSubmit } = useFormContext();

  const onSubmitForm = () => {
    editPrintListTabLoadingService.pub.loading(true);
    const defaultValues = editPrintListService.sub.initialGeneralTabPrintListData;
    const {
      id,
      reportGroupId,
      groupId,
      orderTypesFilter,
      customerListsFilter,
      articleListsFilter,
      tourplanConfigurationData,
      crosstableConfigurationData,
      ...dataForCopy
    } = {
      ...defaultValues,
      ...getValues(),
    };
    editPrintListService.pub.copyPrintList({
      originalId: getValues()?.id,
      data: dataForCopy as Wa_CreateProductionPrintListInput,
    });
  };

  const onCancelCopyMode = () => modeService.pub.mode('edit');

  useEffect(() => {
    const copyEditPrintListSub = editPrintListService.sub
      .copyPrintList()
      .pipe(
        take(1),
        responseHandler<CreateOrCopyPrintListRes>({
          success: () => 'production.edit_print_list_saved',
          customErrorHandler: () => {
            editPrintListTabLoadingService.pub.loading(false);
            return 'production.edit_print_list_not_saved';
          },
          errorReturnType: {
            id: 'errorId',
            name: '',
          },
        }),
      )
      .subscribe(() => editPrintListTabLoadingService.pub.loading(false));

    return () => copyEditPrintListSub.unsubscribe();
  }, []);

  return (
    <>
      <GeneralForm mode={mode} />
      <Box
        sx={{
          mt: 2,
          display: 'flex',
          gap: 2,
        }}
      >
        <Button variant='outlined' onClick={onCancelCopyMode}>
          {t('common.cancel')}
        </Button>
        <Button variant='contained' type='submit' onClick={handleSubmit(onSubmitForm)}>
          {t('production.copy_print_list')}
        </Button>
      </Box>
    </>
  );
};
